import _typeof from "./typeof.js";
import assertThisInitialized from "./assertThisInitialized.js";
export default function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/possibleConstructorReturn.js
// module id = 1787
// module chunks = 0